// Cụm nghiệp vụ nào HỆ ĐANG CHẠY có bán — đọc `modules.<khoá>` trong `@host/tenant` của host.
//
// Luật một chiều: host khai `modules.<khoá> = false` mới là TẮT; không khai (undefined) hay `true` ⇒ BẬT.
// Nhờ vậy Core (config/tenants/*) và CNV Work SaaS (dùng stub kernel `config/tenant.js`) không phải sửa dòng
// nào — mọi cổng dưới đây với họ là "bật" như trước. Chỉ Site Connect khai tắt (sếp Phú 12/10/2026: Site Connect
// không bán CRM / fulfillment, Hộp thư khách hàng, Marketing, Tuyển dụng, Hỗ trợ, Lương, HĐĐT, CNV Call).
//
// ⚠️ `fulfillment` / `etelecom` KHÔNG dùng được làm cổng kiểu này: stub kernel (Work) khai sẵn `false` cho hai khoá
// đó dù Work vẫn mount drawer đơn triển khai ⇒ cổng theo chúng là đổi hành vi Work. Đơn triển khai đi theo `crm`.
//
// ⚠️ KHÔNG import tệp này từ module được nạp ngoài bundler (tools/*.mjs chạy node trần — vd utils/openEntity.js)
// hay từ console Work/Connect (không có alias `@host/tenant`).
import hostTenant from '@host/tenant';

/** Cụm `key` có bật ở hệ này không. Không khai ⇒ bật. */
export function hostModuleOn(key) {
  return hostTenant?.modules?.[key] !== false;
}

export const CRM_ON = hostModuleOn('crm');
export const SUPPORT_ON = hostModuleOn('support');
export const RECRUITMENT_ON = hostModuleOn('recruitment');
export const INBOX_ON = hostModuleOn('inbox');

// ── Automation: nhóm (app / category) + event thuộc cụm nào ─────────────────────────────────────────────────
// Danh mục trigger (BE `/automation/catalog/events`), thư viện mẫu (`/automation/library`) và bộ lọc danh mục của
// danh sách flow đều liệt kê cụm CRM / Tài chính / Triển khai / Hỗ trợ / Hộp thư / Marketing / Tuyển dụng — hệ không
// bán cụm đó thì không mời người ta dựng flow trên event không bao giờ bắn.
const AUTOMATION_GROUP_MODULE = {
  crm: 'crm', finance: 'crm', fulfillment: 'crm',
  support: 'support', inbox: 'inbox', marketing: 'marketing', recruitment: 'recruitment',
};
const AUTOMATION_EVENT_PREFIX_MODULE = [
  ['crm.', 'crm'], ['quotation.', 'crm'], ['fulfillment.', 'crm'],
  ['ticket.', 'support'], ['support.', 'support'], ['inbox.', 'inbox'], ['conversation.', 'inbox'],
  ['marketing.', 'marketing'], ['promotion.', 'marketing'], ['coupon.', 'marketing'], ['recruitment.', 'recruitment'],
];

/** Nhóm automation (app trigger / category thư viện / category flow) có thuộc cụm đang bật không. */
export function automationGroupOn(key) {
  const mod = AUTOMATION_GROUP_MODULE[key];
  return !mod || hostModuleOn(mod);
}

/** Event automation (`crm.deal.won`, `ticket.created`…) có thuộc cụm đang bật không. Không có event ⇒ bật. */
export function automationEventOn(event) {
  const ev = String(event || '');
  const hit = AUTOMATION_EVENT_PREFIX_MODULE.find(([prefix]) => ev.startsWith(prefix));
  return !hit || hostModuleOn(hit[1]);
}

const PassThrough = ({ children }) => children;

/**
 * Provider của một cụm (drawer CRM, ticket…) — cụm tắt ⇒ trả lớp vỏ rỗng: không đăng ký popup với
 * utils/openEntity, không đọc `?dealId=` / `?ticketId=` trên URL, không dựng drawer (mà nội dung drawer gọi hàng
 * chục API của cụm đã tắt). Người gọi `useXxxDrawer()` rơi về giá trị NO_PROVIDER sẵn có của từng context.
 */
export function providerIfModuleOn(key, Provider) {
  return hostModuleOn(key) ? Provider : PassThrough;
}
